import { logoutEndpoint } from './endpoints.js';
import showSnackBar from './snackbar';

export default {
    init: () => {
        const logoutLink = document.querySelector('nav .bottom-of-sidebar a.mdl-navigation__link.text-center.logout-link');
        const loader = document.querySelector('.mdl-spinner.mdl-loader');
        const logout = logoutEndpoint;
        const timeTwo = 2000;
        const enter = 13;

        function onLogOut() {
            localStorage.clear();
            showSnackBar.showMessage('You have been logged out!');
            setTimeout( () => {
                window.location.href = '/';
            }, timeTwo);
        }

        function logoutUser() {
            loader.classList.add('is-active');
            fetch(logout, {
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
            })
                .then((response) => { return response.json(); })
                .then( () => { loader.classList.remove('is-active'); onLogOut(); });
        }
        if ( document.querySelector('nav')) {
            logoutLink.addEventListener('click', (e) => {
                e.preventDefault();
                logoutUser();
            });
            logoutLink.addEventListener('keypress', (e) => {
                e.preventDefault();
                e.keyCode == enter ? logoutUser() : '';
            });
        }
    }
};